module.exports = __webpack_public_path__ + "img/Cast.d8917c69.svg";